/**
 * @voltxampere/components — Independent voltage source
 *
 * Type identifier `"voltage-source"` (lowercase + hyphen) to match
 * SPECS §1.3 ComponentInstance.type regex `/^[a-z][a-z0-9-]*$/`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const VoltageSourceParamsSchema = z
    .object({
    /** DC value in volts. */
    voltage: z.number().finite(),
    /** Optional AC magnitude in volts (for AC analysis, Sprint 8+). */
    acMagnitude: z.number().nonnegative().finite().optional(),
    /** Optional AC phase in degrees. */
    acPhase: z.number().finite().optional(),
    /** Optional pulse waveform parameters (Sprint 6+ transient). */
    pulseParams: z
        .object({
        v1: z.number().finite(),
        v2: z.number().finite(),
        td: z.number().nonnegative().finite(),
        tr: z.number().nonnegative().finite(),
        tf: z.number().nonnegative().finite(),
        pw: z.number().nonnegative().finite(),
        per: z.number().positive().finite(),
    })
        .strict()
        .optional(),
})
    .strict();
export const voltageSourceDefinition = {
    type: "voltage-source",
    category: "source",
    displayName: { tr: "Gerilim Kaynağı", en: "Voltage Source" },
    symbol: "V",
    pins: [
        { id: "pos", side: "top", offset: 0, label: "+" },
        { id: "neg", side: "bottom", offset: 0, label: "-" },
    ],
    parameterSchema: VoltageSourceParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=voltage-source.js.map